import Tabs from "components/lib/Shared/Tabs";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TransactionUpload from "./TransactionUpload";
import UpdateCompanyDetailsContext from "context/UpdateCompanyDetails";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import ManualTransactionReviewContext from "context/ManualTransactionReviewContext";
import { toLower } from "lodash";

/**
 * BRS Forms Uploads Component
 * @param {*} param0
 * @returns {JSX.Element}
 * This component handles the upload of BRS forms for a transaction.
 * It is used by Registrars to upload signed BRS Forms
 * It is also used by the Org Admin to upload unsigned BRS Forms
 */
const BRSFormsUploads = ({
  esignatureIsSelected,
  setESignatureIsSelected,
  goToPrevStep,
  handleConfirmDetails,
  isRegistrar = false,
  handleBackBtn,
  isViewMode,
  manualTransactions = [],
  handleGoBack = () => null,
  handleGoForward = () => null,
  goToNextParentTab,
  setESignatureIsForAdmin,
  defaultTransactions = [],
}) => {
  /** Redux states and hooks */
  const { transactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );

  const { isInUpdateCompanyDetailsContext } = useContext(
    UpdateCompanyDetailsContext
  );
  const { isInManualTransactionReviewContext } = useContext(
    ManualTransactionReviewContext
  );

  /** Tabs setting */
  let transactions = [];
  if (isInUpdateCompanyDetailsContext) {
    transactions = manualTransactions;
  } else {
    if (defaultTransactions?.length > 0) {
      transactions = defaultTransactions;
    } else {
      transactions = transactionUnderReview.items.transactions;
    }
  }

  const initialTabs = transactions.map((trx, index) => {
    return {
      label: toLower(trx?.changeType) || `Transaction ${index + 1}`,
      id: index,
    };
  });
  const [tabs, setTabs] = useState(initialTabs);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  /** Check if is last step */
  const isLastStep = tabs[tabs?.length - 1]?.id === selectedTab?.id;

  /** Go to next tab */
  const goToNextStep = () => {
    setSelectedTabIndex((current) => current + 1);
    if (isLastStep) {
      handleGoForward();
      goToNextParentTab();
    }
  };

  const goBack = () => {
    if (selectedTabIndex === 0) {
      if (isInUpdateCompanyDetailsContext) {
        handleGoBack();
      } else {
        goToPrevStep();
      }
    } else {
      setSelectedTabIndex((current) => current - 1);
    }
  };

  /** Effects */

  /** Update tab selection based on selected index */
  useEffect(() => {
    setSelectedTab(tabs[selectedTabIndex]);
  }, [selectedTabIndex]);

  if (transactions.length > 0) {
    return (
      <div>
        <div>
          <Tabs
            tabs={tabs}
            selectedTabIndex={selectedTabIndex}
            setSelectedTabIndex={setSelectedTabIndex}
          />
        </div>
        <div>
          {transactions.map((trx, index) => {
            if (selectedTab?.id === index) {
              return (
                <TransactionUpload
                  transaction={trx}
                  esignatureIsSelected={esignatureIsSelected}
                  setESignatureIsSelected={setESignatureIsSelected}
                  setESignatureIsForAdmin={setESignatureIsForAdmin}
                  goToPrevStep={goBack}
                  handleConfirmDetails={handleConfirmDetails}
                  isRegistrar={isRegistrar}
                  handleBackBtn={handleBackBtn}
                  isLastStep={isLastStep}
                  goToNextStep={goToNextStep}
                  isViewMode={isViewMode}
                  isInUpdateCompanyDetailsContext={
                    isInUpdateCompanyDetailsContext
                  }
                />
              );
            }
          })}
        </div>
      </div>
    );
  } else {
    return (
      <div className="bg-white w-full h-10">
        <SpinnerIcon />
      </div>
    );
  }
};

export default BRSFormsUploads;
